// eslint-disable-next-line max-len
export const SYNCFUSION_LICENSE = 'Ngo9BigBOggjHTQxAR8/V1NCaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXZedXZURWdeVUJxX0M=';
